
import { reactive, toRefs, onMounted, onBeforeMount, watch, getCurrentInstance, defineEmits } from 'vue'
import {useStore} from 'vuex'
import { setCurrentTenant } from '@/service'
import { $enum } from '@/global'
import { AUTH } from '@/config'
export default {
    name: 'navbar',
    props: {
        isClose: { //菜单列表
            type: Boolean,
            default: false,
        },
        tenantList: {
            type: Array as () => Array<{
                id: string | number;
                name: string;
            }>,
            default: () => [],
        },

    },
    emits: ['onSwitchTenanty'],
    setup(props: any, {emit}: { emit: any}) {
        const store = useStore();
        const { proxy } = getCurrentInstance()!
        const state = reactive({
            currentIndex: 1,
            userInfo: { //用户信息
                userId: '',
                userName: '',
                name: '',
            },
            userActionList: [
                // {
                //     label: '切换机构', value: 1, icon: 'iconfont-line vk_qh_line'
                // },
                {
                    label: '退出登录', value: 2, icon: 'iconfont-line vk_tc_line'
                },
            ],
            currentAction: 0,//当前用户操作
            isShowTenantry: false,//是否显示租户 
            isShowConfirm: false,//是否显示退出确认
        });

        watch(()=>props.isClose, (newVal)=>{
            if(newVal){
                handleCloseUser();
            }
        })

        watch(()=>state.isShowConfirm, (newVal)=>{
            store.commit('viewData/setIsConfirmLogout', newVal);
        })

        /**
         * 切换用户操作
         * @param current 当前用户操作
         * @param type 切换类型 in/out 鼠标移入/移出
         * @returns void
         */
        function handleSwitchAction(current: number, type: 'in' | 'out') {
            if (type === 'in') {
                state.currentAction = current;
                if (current == 1 && !state.isShowTenantry) {//切换租户
                    state.isShowTenantry = true;
                }
                if (current != 1 && state.isShowTenantry) {
                    state.isShowTenantry = false;
                }

            }
            if (type === 'out') {
                if (current != 1 && state.isShowTenantry) {//切换租户
                    state.isShowTenantry = false;
                    state.currentAction = 0;
                }
            }
        }

        function handleCloseUser() {
            state.currentAction = 0;
            state.isShowTenantry = false;
        }

        function handleClick(current: number) {
            window?.playClick()
            if (current == 2) {//退出登录
                state.isShowConfirm = true;
            }
        }

        async function swichTenanty(id?:string | number | null) {
            window?.playClick()
            let {code, data} = await setCurrentTenant({id})
            if(code == $enum.EnumResult.SUCCESS && data){
                proxy?.vknMessage.success('切换机构成功！')
                emit('onSwitchTenanty')
            }else{
                proxy?.vknMessage.error('切换机构失败！')
            }
        }

        function handleCancle(){
            window?.playClick()
            state.isShowConfirm = false;
        }

        function handleConfirm(){
            window?.playClick()
            state.isShowConfirm = false;
            store.commit('persistence/setCurrentTenantId', null);
            store.commit('persistence/setStationId', null);
            store.commit('persistence/setBreadcrumb', [{currentPage:1, path:'/scene',name:'主页',active:true,id:null,courseTypeId:null}]);
            store.commit('persistence/clearCurrentUavInfo');
            store.commit('persistence/setUserInfo', {userId:null,userName:null,name:null,appId:null,phoneNum:null});
            localStorage.clear();
            sessionStorage.clear();
            window.location.replace(window.location.origin + `${AUTH}/logout`);
        }

        onMounted(() => {
            state.userInfo = store.state.persistence.userInfo;
        })

        return {
            ...toRefs(state),
            handleSwitchAction,
            handleClick,
            swichTenanty,
            handleCancle,
            handleConfirm
        }
    }
}
